var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMessage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91536 22.1663H9.33203C4.66536 22.1663 2.33203 20.9997 2.33203 15.1663V9.33301C2.33203 4.66634 4.66536 2.33301 9.33203 2.33301H18.6654C23.332 2.33301 25.6654 4.66634 25.6654 9.33301V15.1663C25.6654 19.833 23.332 22.1663 18.6654 22.1663H18.082C17.7204 22.1663 17.3704 22.3413 17.1487 22.633L15.3987 24.9663C14.6287 25.993 13.3687 25.993 12.5987 24.9663L10.8487 22.633C10.662 22.3763 10.2304 22.1663 9.91536 22.1663Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6629 12.8333H18.6733H18.6629Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6629 12.8333H18.6733",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9949 12.8333H14.0054",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32693 12.8333H9.3374",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/message.87b5c8ff.svg";
export { ForwardRef as ReactComponent };